<div class="padding">
    <div class="card card-1 padding table-wrapper" *ngIf="!is_loading">
        <app-fb-forms-table [storeObj]="RaceTypeCareer"
                            [edit_allowed]="true"
                            [require_filter]="require_filter"
                            (row_click)="rowSelected($event)"
                            [storeExtObj]="ext_obj"
                            [stateKey]="'race_type_careers'"
                            [show_add]="false"
                            [show_add_in_view]="true"
                            [show_delete]="true"
                            (dataLoaded)="dataLoadedDone($event)"
                            [title]="'Careers'"
        >
        </app-fb-forms-table>
    </div>
</div>
